<div style="padding: 32px 40px 40px 40px;max-width: 1078px">
  <div class="title-large" data-testid="title" style="margin-bottom: 32px">User and Permissions</div>
  <div class="overflow-x-auto" style="border: 1px solid #d3d3d8;overflow: hidden;border-radius: 12px">
    <table class="user-access-table">

      <thead style="overflow: hidden">
      <tr>
        <th>User</th>
        @for (option of accessOptions; track option) {
          <th>{{ option }}</th>
        }
      </tr>
      </thead>
      <tbody>
      @for (user of users(); track user.id) {
        <tr>
          <td>{{ user.email }}</td>
          @for (option of accessOptions; track option) {
            <td class="checkbox-cell">
              <input
                type="checkbox"
                [checked]="hasAccess(user, option)"
                (change)="onAccessChange(user, option, $event)"
              >
            </td>
          }
        </tr>
      }
      </tbody>
    </table>
  </div>
</div>
